var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRacingFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8h4v4h-4z",
    fill: "#1a1a2e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8h2v2h-2z",
    fill: "#1a1a2e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12h2v2h-2z",
    fill: "#1a1a2e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacingFlag);
export default __webpack_public_path__ + "static/media/racing-flag.1037cd117c98ffe22e23a0f13cc34320.svg";
export { ForwardRef as ReactComponent };